var map = {
	"./alhitham.png": 8334,
	"./arizona.png": 9236,
	"./carmarket.png": 6802,
	"./dalel.png": 2412,
	"./elgomhoria.png": 1809,
	"./elmohandes.png": 9838,
	"./kayan.png": 4516,
	"./tashteeb.png": 8582,
	"./tnt.png": 3658,
	"./winch.png": 6127,
	"./winchenqaz.png": 1528
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 580;